export default "__VITE_ASSET__CVOHYjDU__"